module.exports = __webpack_public_path__ + "img/TABLE.9c28e484.svg";